import React from "react";
import Label from "../atoms/Label";
import Link from "../atoms/Link";
import showModal, { OpenModalTrigger } from "./Modal";
import contentfulRichText from "../util/contentfulRichText";
import Image from "../atoms/Image";

export default ({ label, title, image, logo, link, alignLeft, price, modalText, modalImage, translations }) => {

  const modalContent = (
    <>
      { modalImage ? <Image image={ modalImage }/> : <Image image={ image }/> }
      <div className="o-modal__content o-modal__content--bg">
        { contentfulRichText(modalText) }
        { link && <Link link={ link }> { link.title } </Link> }
      </div>
    </>
  )

    const openModal = () => {
        const element = (
            <>
            { modalImage ?
                <Image image={ modalImage }/>
                :
                <Image image={ image }/>
            }
            <div className="o-modal__content o-modal__content--bg">
                { contentfulRichText(modalText) }
                { link && <Link link={ link }> { link.title } </Link> }
            </div>
            </>
        );

        {
            modalText &&
            showModal({ children: element, translations })
        }
    };

    return (
        (modalText != null || !link) ?
            
            <OpenModalTrigger className="o-promo u-object-fit u-object-fit--2-3" modalContent={ modalContent }>
                <Image className="o-promo__background u-object-fit__media" image={ image }/>
                <div className={ "o-promo__content" + (alignLeft ? " o-promo__content--left" : "") }>
                    { (logo) && <img className="o-promo__logo" src={ logo.file.url } alt={ logo.title }/> }
                    <Label text={ label }/>
                    { (!logo && title) && <p className="o-promo__content-title">{ title }</p> }
                    { price && <p className="o-promo__content-price">{ price }</p> }
                </div>
            </OpenModalTrigger>
            :
            <Link className="o-promo u-object-fit u-object-fit--2-3" link={ link } translations={ translations } >
                <Image className="o-promo__background u-object-fit__media" image={ image }/>
                <div className={ "o-promo__content" + (alignLeft ? " o-promo__content--left" : "") }>
                    { (logo) && <img className="o-promo__logo" src={ logo.file.url } alt={ logo.title }/> }
                    <Label text={ label }/>
                    { (!logo && title) && <p className="o-promo__content-title">{ title }</p> }
                    { price && <p className="o-promo__content-price">{ price }</p> }
                </div>
            </Link>

    );
}
